<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "Russia",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "电子商务交易额及其增长率",
                        data: "dtime",
                        unit: "亿美元"
                    },
                    {
                        name: "网络零售交易额及其增长率",
                        data: "a100",
                        unit: "亿美元"
                    },
                    {
                        name: "互联网普及率及其增长率",
                        data: "a102",
                        unit: "%"
                    },
                ],
                cate: '俄罗斯'
            }
        }
    },
    created() {
        this.$store.dispatch('getGlobal', this.params)
    }
}
</script>

<style scoped>
#app .content-left .el-menu-vertical-demo {
    width: 200px;
}
</style>